import { render } from "./Stamps.vue?vue&type=template&id=14c11152&scoped=true"
import script from "./Stamps.vue?vue&type=script&lang=js"
export * from "./Stamps.vue?vue&type=script&lang=js"

import "./Stamps.vue?vue&type=style&index=0&id=14c11152&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14c11152"]])

export default __exports__